import {
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';

import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import {
  ActivatedRoute,
  Router
} from '@angular/router';

import {
  Subject,
  takeUntil
} from 'rxjs';

import { ApiService } from '../../core/api.service';
import { CartService } from '../../core/cart.service';

interface ActiveOrder {
  trackingCode: string;
  restaurantId: number;
  restaurantSlug?: string;
  status?: string;
}

@Component({
  selector: 'app-public-menu',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './public-menu.component.html',
  styleUrl: './public-menu.component.css'
})
export class PublicMenuComponent implements OnInit, OnDestroy {

  restaurant: any;

  loading = true;
  error = '';

  cartOpen = false;
  sending = false;
  couponCode = '';

  couponLoading = false;

  couponError = '';
deliveryFeeLoading = false;

deliveryFeeCalculated = false;

deliveryAvailable: boolean | null = null;

calculatedDeliveryFee = 0;

deliveryFeeError = '';

deliveryRegionName = '';
  appliedCoupon: any = null;

  discountAmount = 0;

  customerLogged: any = JSON.parse(
    localStorage.getItem('customer_user') || 'null'
  );

  selectedProduct: any = null;
  productModalOpen = false;
  productQuantity = 0;
  productObservation = '';

  cartItems: any[] = [];

searchText = '';

filtersOpen = false;

selectedCategoryId: number | null = null;

priceOrder: 'DEFAULT' | 'LOWEST' | 'HIGHEST' = 'DEFAULT';

onlyAvailable = false;


  activeOrder: ActiveOrder | null = null;

  private readonly destroy$ = new Subject<void>();

  private readonly activeOrderStatuses = [
    'PENDING',
    'ACCEPTED',
    'PREPARING',
    'READY',
    'OUT_FOR_DELIVERY'
  ];

customer: any = {
  customerName: '',
  customerPhone: '',
  customerAddress: '',
  customerZipCode: '',
  tableNumber: '',
  deliveryType: 'DELIVERY',
  notes: ''
};





selectDeliveryType(
  type: 'DELIVERY' | 'PICKUP' | 'TABLE'
): void {

  this.customer.deliveryType = type;

  /*
   * Retirada e mesa nunca possuem frete.
   */
  if (
    type === 'PICKUP' ||
    type === 'TABLE'
  ) {
    this.calculatedDeliveryFee = 0;
    this.deliveryFeeCalculated = false;
    this.deliveryAvailable = null;
    this.deliveryFeeError = '';
    this.deliveryRegionName = '';

    return;
  }

  /*
   * Voltou para Delivery.
   *
   * Se for taxa fixa,
   * já podemos mostrar o valor.
   */
  if (
    this.restaurant?.deliveryFeeType ===
    'FIXED'
  ) {
    this.calculatedDeliveryFee =
      Number(
        this.restaurant?.deliveryFee || 0
      );

    this.deliveryFeeCalculated = true;
    this.deliveryAvailable = true;

    return;
  }

  /*
   * Se já existe CEP digitado,
   * recalcula automaticamente.
   */
  if (
    this.normalizeZipCode(
      this.customer.customerZipCode
    ).length === 8
  ) {
    this.calculateDeliveryFee();
  }
}




normalizeZipCode(
  value: any
): string {

  return String(
    value ?? ''
  )
    .replace(/\D/g, '')
    .slice(0, 8);
}


formatZipCode(
  value: any
): string {

  const digits =
    this.normalizeZipCode(value);

  if (
    digits.length <= 5
  ) {
    return digits;
  }

  return (
    digits.slice(0, 5) +
    '-' +
    digits.slice(5)
  );
}


onZipCodeInput(): void {

  this.customer.customerZipCode =
    this.formatZipCode(
      this.customer.customerZipCode
    );

  /*
   * Alterou o CEP:
   * o cálculo anterior deixa
   * de ser válido.
   */
  this.deliveryFeeCalculated = false;
  this.deliveryAvailable = null;
  this.deliveryFeeError = '';
  this.deliveryRegionName = '';

  if (
    this.restaurant?.deliveryFeeType ===
    'ZIP_CODE'
  ) {
    this.calculatedDeliveryFee = 0;
  }
}

calculateDeliveryFee(): void {

  if (
    this.customer.deliveryType !==
    'DELIVERY'
  ) {
    this.calculatedDeliveryFee = 0;
    this.deliveryFeeCalculated = false;
    this.deliveryAvailable = null;

    return;
  }


  if (
    !this.restaurant?.slug
  ) {
    this.deliveryFeeError =
      'Restaurante não identificado.';

    return;
  }


  /*
   * TAXA FIXA
   *
   * Não precisa consultar CEP.
   */
  if (
    this.restaurant?.deliveryFeeType ===
    'FIXED'
  ) {
    this.calculatedDeliveryFee =
      Number(
        this.restaurant?.deliveryFee || 0
      );

    this.deliveryFeeCalculated = true;
    this.deliveryAvailable = true;
    this.deliveryFeeError = '';
    this.deliveryRegionName = '';

    return;
  }


  const zipCode =
    this.normalizeZipCode(
      this.customer.customerZipCode
    );


  if (
    zipCode.length !== 8
  ) {
    this.deliveryFeeError =
      'Informe um CEP válido.';

    this.deliveryFeeCalculated = false;
    this.deliveryAvailable = null;

    return;
  }


  this.deliveryFeeLoading = true;

  this.deliveryFeeError = '';

  this.deliveryAvailable = null;

  this.deliveryRegionName = '';


  this.api
    .post<any>(
      `/public/restaurants/${encodeURIComponent(
        this.restaurant.slug
      )}/delivery-fee`,
      {
        zipCode
      }
    )
    .pipe(
      takeUntil(
        this.destroy$
      )
    )
    .subscribe({

      next: response => {

        this.deliveryFeeLoading = false;

        this.deliveryFeeCalculated = true;

        this.deliveryAvailable =
          response?.available === true;


        if (
          !this.deliveryAvailable
        ) {
          this.calculatedDeliveryFee = 0;

          this.deliveryRegionName = '';

          this.deliveryFeeError =
            response?.message ||
            'Ainda não entregamos neste CEP.';

          return;
        }


        this.calculatedDeliveryFee =
          Number(
            response?.deliveryFee || 0
          );


        this.deliveryRegionName =
          response?.region?.name || '';


        this.deliveryFeeError = '';
      },


      error: error => {

        this.deliveryFeeLoading = false;

        this.deliveryFeeCalculated = false;

        this.deliveryAvailable = null;

        this.calculatedDeliveryFee = 0;


        this.deliveryFeeError =
          error?.error?.message ||
          'Não foi possível calcular a taxa de entrega.';
      }

    });
}







toggleFilters(): void {
  this.filtersOpen = !this.filtersOpen;
}


closeFilters(): void {
  this.filtersOpen = false;
}


clearFilters(): void {
  this.searchText = '';
  this.selectedCategoryId = null;
  this.priceOrder = 'DEFAULT';
  this.onlyAvailable = false;
}


selectCategoryFilter(
  categoryId: number | null
): void {

  this.selectedCategoryId = categoryId;
}


normalizeSearchText(value: any): string {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}


productMatchesSearch(product: any): boolean {

  const search =
    this.normalizeSearchText(
      this.searchText
    );

  if (!search) {
    return true;
  }

  const name =
    this.normalizeSearchText(
      product?.name
    );

  const description =
    this.normalizeSearchText(
      product?.description
    );

  return (
    name.includes(search) ||
    description.includes(search)
  );
}


productMatchesFilters(
  product: any,
  categoryId?: number
): boolean {

  if (
    this.selectedCategoryId !== null &&
    Number(categoryId) !==
      Number(this.selectedCategoryId)
  ) {
    return false;
  }

  if (
    this.onlyAvailable &&
    product?.isActive === false
  ) {
    return false;
  }

  return this.productMatchesSearch(product);
}


filteredCategoryProducts(
  category: any
): any[] {

  let products = [
    ...(category?.products || [])
  ];

  products = products.filter(
    product =>
      this.productMatchesFilters(
        product,
        category?.id
      )
  );

  if (
    this.priceOrder === 'LOWEST'
  ) {

    products.sort(
      (a, b) =>
        Number(a?.price || 0) -
        Number(b?.price || 0)
    );
  }

  if (
    this.priceOrder === 'HIGHEST'
  ) {

    products.sort(
      (a, b) =>
        Number(b?.price || 0) -
        Number(a?.price || 0)
    );
  }

  return products;
}


categoryHasVisibleProducts(
  category: any
): boolean {

  return (
    this.filteredCategoryProducts(
      category
    ).length > 0
  );
}


get hasActiveFilters(): boolean {

  return Boolean(
    this.searchText.trim() ||
    this.selectedCategoryId !== null ||
    this.priceOrder !== 'DEFAULT' ||
    this.onlyAvailable
  );
}









  constructor(
    private readonly route: ActivatedRoute,
    private readonly api: ApiService,
    private readonly router: Router,
    public readonly cart: CartService
  ) { }

  ngOnInit(): void {
    this.subscribeToCart();
    this.fillCustomerData();
    this.loadRestaurant();
  }

  // private subscribeToCart(): void {
  //   this.cart.items$
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe(items => {
  //       this.cartItems = items;
  //     });
  // }


  private subscribeToCart(): void {
  this.cart.items$
    .pipe(
      takeUntil(
        this.destroy$
      )
    )
    .subscribe(items => {

      this.cartItems =
        items;

      /*
       * Se o cliente alterar o carrinho
       * depois de aplicar o cupom,
       * precisamos validar novamente.
       */
      if (
        this.appliedCoupon
      ) {
        this.removeCoupon(
          false
        );
      }

    });
}




deliveryFeeAmount(): number {

  /*
   * Mesa e retirada:
   * SEMPRE zero.
   */
  if (
    this.customer.deliveryType !==
    'DELIVERY'
  ) {
    return 0;
  }


  /*
   * Taxa fixa.
   */
  if (
    this.restaurant?.deliveryFeeType ===
    'FIXED'
  ) {
    return Number(
      this.restaurant?.deliveryFee || 0
    );
  }


  /*
   * Taxa por CEP.
   *
   * Somente considera depois
   * de um CEP válido calculado.
   */
  if (
    this.restaurant?.deliveryFeeType ===
      'ZIP_CODE' &&
    this.deliveryFeeCalculated &&
    this.deliveryAvailable === true
  ) {
    return Number(
      this.calculatedDeliveryFee || 0
    );
  }


  return 0;
}


orderTotal(): number {

  const subtotal =
    this.total();

  const deliveryFee =
    this.deliveryFeeAmount();

  const discount =
    Number(
      this.discountAmount ||
      0
    );

  return Math.max(
    0,
    Number(
      (
        subtotal -
        discount +
        deliveryFee
      ).toFixed(2)
    )
  );
}






removeCoupon(
  clearCode = true
): void {

  this.appliedCoupon =
    null;

  this.discountAmount =
    0;

  this.couponError =
    '';

  if (clearCode) {
    this.couponCode =
      '';
  }
}




applyCoupon(): void {

  const code =
    String(this.couponCode || '')
      .trim()
      .toUpperCase();

  if (!code) {
    this.couponError =
      'Informe um cupom.';

    return;
  }

  if (!this.restaurant?.id) {
    this.couponError =
      'Restaurante não identificado.';

    return;
  }

  const cartItems =
    this.cart.getItems();

  if (!cartItems.length) {
    this.couponError =
      'Adicione produtos ao pedido antes de aplicar o cupom.';

    return;
  }

  const items =
    cartItems.map(
      (item: any) => ({
        productId:
          item.product.id,

        quantity:
          item.quantity
      })
    );

  this.couponLoading = true;
  this.couponError = '';

  this.api
    .post<any>(
      `/public/restaurants/${this.restaurant.id}/coupons/validate`,
      {
        code,
        items
      }
    )
    .pipe(
      takeUntil(
        this.destroy$
      )
    )
    .subscribe({

      next: response => {

        this.couponLoading = false;

        if (
          response?.valid !== true
        ) {
          this.appliedCoupon = null;
          this.discountAmount = 0;

          this.couponError =
            response?.message ||
            'Cupom inválido.';

          return;
        }

        this.couponCode = code;

        this.appliedCoupon =
          response?.coupon || {
            code
          };

        this.discountAmount =
          Number(
            response?.discount ||
            0
          );

        this.couponError = '';

        console.log(
          'Cupom aplicado:',
          response
        );
      },

      error: error => {

        this.couponLoading = false;

        this.appliedCoupon = null;
        this.discountAmount = 0;

        this.couponError =
          error?.error?.message ||
          'Não foi possível aplicar o cupom.';

        console.error(
          'Erro ao aplicar cupom:',
          error
        );
      }

    });
}




get restaurantIsOpen(): boolean {

  /*
   * Compatibilidade com resposta antiga.
   */
  if (
    this.restaurant
      ?.openingStatus
      ?.isOpen !== undefined
  ) {
    return (
      this.restaurant
        .openingStatus
        .isOpen === true
    );
  }


  return (
    this.restaurant?.isOpen !==
    false
  );
}


getOpeningStatusText(): string {

  const status =
    this.restaurant
      ?.openingStatus;


  if (!status) {

    return this.restaurantIsOpen
      ? 'Aberto agora'
      : 'Fechado';
  }


  /*
   * ABERTO
   */
  if (status.isOpen) {

    if (
      status.closesAt
    ) {
      return (
        `Aberto agora · Fecha às ${status.closesAt}`
      );
    }


    return 'Aberto agora';
  }


  /*
   * FECHAMENTO MANUAL
   */
  if (
    status.manualClosed ||
    status.reason ===
      'MANUALLY_CLOSED'
  ) {
    return (
      'Fechado temporariamente'
    );
  }


  /*
   * FECHADO PELO HORÁRIO
   */
  const nextOpen =
    status.nextOpen;


  if (!nextOpen) {
    return 'Fechado';
  }


  if (
    nextOpen.daysAhead === 0
  ) {
    return (
      `Fechado · Abre às ${nextOpen.openTime}`
    );
  }


  if (
    nextOpen.daysAhead === 1
  ) {
    return (
      `Fechado · Abre amanhã às ${nextOpen.openTime}`
    );
  }


  return (
    `Fechado · Abre ${this.getWeekDayLabel(
      nextOpen.dayOfWeek
    )} às ${nextOpen.openTime}`
  );
}


private getWeekDayLabel(
  day:
    string
): string {

  const labels:
    Record<string, string> = {

      SUNDAY:
        'domingo',

      MONDAY:
        'segunda',

      TUESDAY:
        'terça',

      WEDNESDAY:
        'quarta',

      THURSDAY:
        'quinta',

      FRIDAY:
        'sexta',

      SATURDAY:
        'sábado'
    };


  return (
    labels[day] ||
    ''
  );
}





  private loadRestaurant(): void {
    const slug = this.route.snapshot.paramMap.get('slug');

    if (!slug) {
      this.error = 'Restaurante não informado.';
      this.loading = false;
      return;
    }

    this.api
      .get<any>(`/public/restaurants/${encodeURIComponent(slug)}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: data => {
          this.restaurant = data;
          this.loading = false;
          this.error = '';

          this.loadActiveOrder();


          if (
            history.state?.openCart &&
            this.cart.getItems().length > 0
          ) {
            this.cartOpen = true;
          }

        },
        error: error => {
          console.error(
            'Erro ao carregar restaurante:',
            error
          );

          this.error = 'Cardápio não encontrado.';
          this.loading = false;
        }
      });
  }

  fillCustomerData(): void {
    if (!this.customerLogged) {
      return;
    }

    this.customer.customerName =
      this.customerLogged.name || '';

    this.customer.customerPhone =
      this.customerLogged.phone || '';
  }

  total(): number {
    return this.cart.total();
  }


  finishOrder123(): void {
    if (this.sending) {
      return;
    }

    const items = this.cart.getItems();

    if (!items.length) {
      alert('Adicione pelo menos um item.');
      return;
    }

    if (
      !this.customer.customerName?.trim() ||
      !this.customer.customerPhone?.trim()
    ) {
      alert('Informe nome e telefone.');
      return;
    }

    if (!this.restaurant?.id) {
      alert('Restaurante não identificado.');
      return;
    }

    if (
      this.customer.deliveryType === 'DELIVERY' &&
      !this.customer.customerAddress?.trim()
    ) {
      alert('Informe o endereço de entrega.');
      return;
    }

    if (
      this.customer.deliveryType === 'TABLE' &&
      !this.customer.tableNumber?.trim()
    ) {
      alert('Informe o número da mesa.');
      return;
    }

const payload = {
  restaurantId:
    this.restaurant.id,

  customerName:
    this.customer
      .customerName
      .trim(),

  customerPhone:
    this.customer
      .customerPhone
      .trim(),

  customerAddress:
    this.customer
      .deliveryType ===
      'DELIVERY'
        ? this.customer
            .customerAddress
            ?.trim() ||
          ''
        : '',

  tableNumber:
    this.customer
      .deliveryType ===
      'TABLE'
        ? this.customer
            .tableNumber
            ?.trim() ||
          ''
        : '',

  deliveryType:
    this.customer
      .deliveryType,

  notes:
    this.customer
      .notes
      ?.trim() ||
    '',

  /*
   * NOVO
   */
  couponCode:
    this.appliedCoupon
      ? this.couponCode
      : null,

  items:
    items.map(
      (item: any) => ({

        productId:
          item.product.id,

        quantity:
          item.quantity,

        notes:
          item.notes
            ?.trim() ||
          ''

      })
    )
};

    this.sending = true;

    this.api
      .post<any>('/public/orders', payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          this.sending = false;

          const order = response?.order;
          const trackingCode = order?.trackingCode;

          if (!trackingCode) {
            console.error(
              'Resposta sem trackingCode:',
              response
            );

            alert(
              'Pedido criado, mas o código de acompanhamento não foi retornado.'
            );

            return;
          }

          this.saveActiveOrder({
            trackingCode,
            restaurantId: this.restaurant.id,
            restaurantSlug: this.restaurant.slug,
            status: order.status || 'PENDING'
          });

          this.cart.clear();
          this.cartOpen = false;
          this.removeCoupon();

          if (response?.whatsappUrl) {
            window.open(
              response.whatsappUrl,
              '_blank',
              'noopener,noreferrer'
            );
          }

          this.router.navigate(
            ['/pedido', trackingCode],
            {
              state: {
                restaurantSlug:
                  this.restaurant.slug
              }
            }
          );
        },

        error: error => {
          this.sending = false;

          console.error(
            'Erro ao criar pedido:',
            error
          );

          alert(
            error?.error?.message ||
            'Erro ao criar pedido.'
          );
        }
      });
  }

finishOrder(): void {
  if (this.sending) {
    return;
  }


if (
  !this.restaurantIsOpen
) {
  alert(
    this.getOpeningStatusText()
  );

  return;
}


  const items = this.cart.getItems();

  if (!items.length) {
    alert('Adicione pelo menos um item.');
    return;
  }

  if (
    !this.customer.customerName?.trim() ||
    !this.customer.customerPhone?.trim()
  ) {
    alert('Informe nome e telefone.');
    return;
  }

  if (!this.restaurant?.id) {
    alert('Restaurante não identificado.');
    return;
  }

  if (
    this.customer.deliveryType === 'DELIVERY' &&
    !this.customer.customerAddress?.trim()
  ) {
    alert('Informe o endereço de entrega.');
    return;
  }

  if (
    this.customer.deliveryType === 'TABLE' &&
    !this.customer.tableNumber?.trim()
  ) {
    alert('Informe o número da mesa.');
    return;
  }


if (
  this.customer.deliveryType ===
    'DELIVERY' &&
  this.restaurant?.deliveryFeeType ===
    'ZIP_CODE'
) {

  const zipCode =
    this.normalizeZipCode(
      this.customer.customerZipCode
    );


  if (
    zipCode.length !== 8
  ) {
    alert(
      'Informe um CEP válido para a entrega.'
    );

    return;
  }


  if (
    !this.deliveryFeeCalculated ||
    this.deliveryAvailable !== true
  ) {
    alert(
      'Calcule a taxa de entrega antes de continuar.'
    );

    return;
  }
}





  const payload = {
    restaurantId: this.restaurant.id,

    customerName:
      this.customer.customerName.trim(),

    customerPhone:
      this.customer.customerPhone.trim(),

    customerAddress:
      this.customer.deliveryType === 'DELIVERY'
        ? this.customer.customerAddress?.trim() || ''
        : '',

        customerZipCode:
  this.customer.deliveryType === 'DELIVERY'
    ? this.normalizeZipCode(
        this.customer.customerZipCode
      )
    : '',

    tableNumber:
      this.customer.deliveryType === 'TABLE'
        ? this.customer.tableNumber?.trim() || ''
        : '',

    deliveryType:
      this.customer.deliveryType,

    notes:
      this.customer.notes?.trim() || '',

    couponCode:
      this.appliedCoupon
        ? this.couponCode
        : null,

    items: items.map(
      (item: any) => ({
        productId: item.product.id,
        quantity: item.quantity,
        notes: item.notes?.trim() || ''
      })
    )
  };

  this.sending = true;

  this.api
    .post<any>('/public/orders', payload)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: response => {
        this.sending = false;

        const order = response?.order;
        const trackingCode = order?.trackingCode;

        if (!trackingCode) {
          console.error(
            'Resposta sem trackingCode:',
            response
          );

          alert(
            'Pedido criado, mas o código de acompanhamento não foi retornado.'
          );

          return;
        }

        this.saveActiveOrder({
          trackingCode,
          restaurantId: this.restaurant.id,
          restaurantSlug: this.restaurant.slug,
          status: order.status || 'PENDING'
        });

        this.cart.clear();
        this.cartOpen = false;
        this.removeCoupon();

        const whatsappUrl =
          response?.whatsappUrl;

        if (whatsappUrl) {
          const isMobile =
            /Android|iPhone|iPad|iPod/i.test(
              navigator.userAgent
            );

          if (isMobile) {
            /*
             * No celular, redireciona diretamente
             * para evitar bloqueio de popup.
             */
            window.location.href =
              whatsappUrl;

            return;
          }

          /*
           * No desktop, abre o WhatsApp
           * em uma nova aba.
           */
          window.open(
            whatsappUrl,
            '_blank',
            'noopener,noreferrer'
          );
        }

        /*
         * No desktop, continua para
         * a página de acompanhamento.
         */
        this.router.navigate(
          ['/pedido', trackingCode],
          {
            state: {
              restaurantSlug:
                this.restaurant.slug
            }
          }
        );
      },

      error: error => {
        this.sending = false;

        console.error(
          'Erro ao criar pedido:',
          error
        );

        alert(
          error?.error?.message ||
          'Erro ao criar pedido.'
        );
      }
    });
}


  private getActiveOrderStorageKey(
    restaurantId: number
  ): string {
    return `activeOrder_${restaurantId}`;
  }


  private saveActiveOrder(
    order: ActiveOrder
  ): void {
    const storageKey =
      this.getActiveOrderStorageKey(order.restaurantId);

    localStorage.setItem(
      storageKey,
      JSON.stringify(order)
    );

    this.activeOrder = order;
  }







  loadActiveOrder(): void {
    if (!this.restaurant?.id) {
      return;
    }

    const storageKey =
      this.getActiveOrderStorageKey(this.restaurant.id);

    const savedOrder =
      localStorage.getItem(storageKey);

    if (!savedOrder) {
      this.activeOrder = null;
      return;
    }

    try {
      const parsedOrder =
        JSON.parse(savedOrder) as ActiveOrder;

      if (
        !parsedOrder?.trackingCode ||
        !parsedOrder?.restaurantId
      ) {
        this.removeActiveOrder();
        return;
      }

      this.api
        .get<any>(
          //  `/orders/tracking/${parsedOrder.trackingCode}`
          `/orders/tracking/${encodeURIComponent(parsedOrder.trackingCode)}`
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: order => {
            if (
              this.activeOrderStatuses.includes(
                order.status
              )
            ) {
              this.activeOrder = {
                trackingCode:
                  order.trackingCode,

                restaurantId:
                  order.restaurant?.id ||
                  parsedOrder.restaurantId,

                status:
                  order.status
              };

              localStorage.setItem(
                storageKey,
                JSON.stringify(this.activeOrder)
              );

              return;
            }

            this.removeActiveOrder();
          },
          error: error => {
            console.error(
              'Erro ao consultar pedido ativo:',
              error
            );

            if (error?.status === 404) {
              this.removeActiveOrder();
              return;
            }

            this.activeOrder = parsedOrder;
          }

        });
    } catch (error) {
      console.error(
        'Erro ao ler pedido salvo:',
        error
      );

      this.removeActiveOrder();
    }
  }

  removeActiveOrder(): void {
    if (this.restaurant?.id) {
      localStorage.removeItem(
        this.getActiveOrderStorageKey(
          Number(this.restaurant.id)
        )
      );
    }

    this.activeOrder = null;
  }

  goToActiveOrder(): void {
    if (!this.activeOrder?.trackingCode) {
      return;
    }

    this.router.navigate([
      '/pedido',
      this.activeOrder.trackingCode
    ]);
  }

  getActiveOrderStatusLabel(): string {
    const labels: Record<string, string> = {
      PENDING: 'Pedido recebido',
      ACCEPTED: 'Pedido confirmado',
      PREPARING: 'Seu pedido está em preparo',
      READY: 'Seu pedido está pronto',
      OUT_FOR_DELIVERY: 'Seu pedido está a caminho'
    };

    return labels[
      this.activeOrder?.status || ''
    ] || 'Acompanhar pedido';
  }

  // goToCustomerLogin(): void {
  //   this.router.navigate(
  //     ['/customer/login'],
  //     {
  //       queryParams: {
  //         returnUrl: this.router.url
  //       }
  //     }
  //   );
  // }


  goToCustomerLogin(): void {

  const returnUrl = this.router.url;

  // Guarda o cardápio atual como segurança
  sessionStorage.setItem(
    'customer_return_url',
    returnUrl
  );

  this.router.navigate(
    ['/customer/login'],
    {
      queryParams: {
        returnUrl
      }
    }
  );
}


  scrollToCategory(categoryId: number): void {
    const element =
      document.getElementById(
        `cat-${categoryId}`
      );

    if (!element) {
      return;
    }

    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }




  // goToCustomerRegister(): void {
  //   this.router.navigate(
  //     ['/customer/register'],
  //     {
  //       queryParams: {
  //         returnUrl: this.router.url
  //       }
  //     }
  //   );
  // }


goToCustomerRegister(): void {

  const returnUrl = this.router.url;

  sessionStorage.setItem(
    'customer_return_url',
    returnUrl
  );

  this.router.navigate(
    ['/customer/register'],
    {
      queryParams: {
        returnUrl
      }
    }
  );
}


  // goToMyOrders(): void {
  //   this.router.navigate([
  //     '/customer/orders'
  //   ]);
  // }



  goToMyOrders(): void {

  // Guarda o cardápio atual
  sessionStorage.setItem(
    'customer_return_url',
    this.router.url
  );

  this.router.navigate([
    '/customer/orders'
  ]);
}

  logoutCustomer(): void {
    localStorage.removeItem(
      'customer_token'
    );

    localStorage.removeItem(
      'customer_user'
    );

    this.customerLogged = null;

    this.customer.customerName = '';
    this.customer.customerPhone = '';
  }

  openProduct(product: any): void {
    const items = this.cart.getItems();

    const quantityInCart = items
      .filter(item =>
        Number(item.product.id) ===
        Number(product.id)
      )
      .reduce(
        (total, item) =>
          total + item.quantity,
        0
      );

    this.selectedProduct = product;
    this.productQuantity = quantityInCart;
    this.productObservation = '';
    this.productModalOpen = true;
  }

  closeProductModal(): void {
    this.selectedProduct = null;
    this.productQuantity = 0;
    this.productObservation = '';
    this.productModalOpen = false;
  }

  increaseProductQuantity(): void {
    this.productQuantity++;
  }

  decreaseProductQuantity(): void {
    if (this.productQuantity > 0) {
      this.productQuantity--;
    }
  }

  addSelectedProduct(): void {
    if (
      !this.selectedProduct ||
      this.productQuantity <= 0
    ) {
      return;
    }

    this.cart.setItemQuantity(
      this.selectedProduct,
      this.productQuantity,
      this.productObservation?.trim() || ''
    );

    this.closeProductModal();
  }

  getImageUrl(
    imageUrl: string
  ): string {
    if (!imageUrl) {
      return '';
    }

    if (
      imageUrl.startsWith('http://') ||
      imageUrl.startsWith('https://')
    ) {
      return imageUrl;
    }

    return `http://localhost:3000${imageUrl}`;
  }

  formatMoney(value: any): string {
    return new Intl.NumberFormat(
      'pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }
    ).format(Number(value || 0));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}